exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title {\n  font-weight: 600; }\n\n.status {\n  border: 1px solid;\n  border-radius: 4px;\n  padding: 2px; }\n\n.PendingActivation {\n  color: white;\n  border-color: orange;\n  background-color: orange; }\n\n.Active {\n  color: white;\n  border-color: green;\n  background-color: green; }\n\n.Inactive {\n  color: white;\n  border-color: black;\n  background-color: black; }\n\n.Decline {\n  color: white;\n  border-color: red;\n  background-color: red; }\n\n.New {\n  color: white;\n  border-color: blue;\n  background-color: blue; }\n\nimg {\n  width: 70px;\n  margin-right: 0.5rem;\n  border-radius: 4px; }\n\n.footer {\n  background-color: #f1f1f8; }\n\n.card-footer {\n  background-color: #ffffff; }\n\n.files {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/pages/hotel-register-requests/hotel-register-requests.component.scss
// module id = ../../../../../src/app/main/pages/hotel-register-requests/hotel-register-requests.component.scss
// module chunks = main